import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { theme } from './theme';

const headerContainer = css`
  text-align: center;
  margin: ${theme.spacing.xl} 0 ${theme.spacing.xl} 0;

  @media (max-width: ${theme.breakpoints.tablet}) {
    margin: ${theme.spacing.xl} 0 ${theme.spacing.lg} 0;
    font-size: ${theme.fontSize.xxl};
  }
`;

const headerParagraph = css`
  margin: 0;
  font-size: ${theme.fontSize.lg};

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: ${theme.fontSize.md};
  }
`;

const titleHeader = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.sm};
`;

const h1 = css`
  margin: 0;
`;
type Props = {
  title: string;
  children?: ReactElement | string;
  className?: string;
  icon?: ReactElement;
};

export const PageHeader = ({ title, children, className, icon }: Props) => {
  return (
    <div css={headerContainer} className={className}>
      <div css={titleHeader}>
        <h1 css={h1}>{title}</h1>
        {icon && icon}
      </div>
      {children !== undefined && <p css={headerParagraph}>{children}</p>}
    </div>
  );
};
